export enum ModalContextDispatchActionType {
	SetModalComponent,
	OpenModal,
	CloseModal,
	SetPreventClose,
	SetCustomCloseCallback,
	SetCustomClassName,
}
